export default "__VITE_ASSET__CIiDXK8P__"